"use client"

import Link from "next/link"
import { useParams } from "next/navigation"
import { useTranslations } from "next-intl"
import { DirectionIcon, Typography } from "@/shared/ui/atoms"
import { buildHospitalDetailPathFromSegments } from "@/entities/hospital/lib/detail-route"

/**
 * 사진 전체 페이지로 나가는 링크.
 *
 * 상세 페이지가 URL 라벨을 이미 정본으로 맞춰 놓은 뒤이므로 현재 라우트 세그먼트를
 * 그대로 이어 붙인다 — 이름을 다시 조회해 슬러그를 만들 필요가 없다.
 */
const HospitalImagesMoreLink = () => {
  const t = useTranslations()
  const { locale, region, treatment, id } = useParams() as {
    locale?: string
    region?: string
    treatment?: string
    id?: string
  }

  if (!locale || !region || !treatment || !id) return null

  return (
    <Link
      href={buildHospitalDetailPathFromSegments({
        locale,
        regionSegment: region,
        treatmentSegment: treatment,
        hospitalOriginId: id,
        sub: "images",
      })}
      className="inline-flex items-center text-gray-600 hover:text-primary-700"
    >
      <Typography as="span" size={14} lineHeight={20}>
        {t("common.more")}
      </Typography>
      <DirectionIcon size={16} rotate={270} className="text-gray-400" />
    </Link>
  )
}

export default HospitalImagesMoreLink
